module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.condition) ? _c('div', {
    staticClass: "bgnothing"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/nothing.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "bgtext"
  }, [_vm._v(_vm._s(_vm.getDis()))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-02f78cb7","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaCommon/nothing.vue
// module id = 1722
// module chunks = 107